import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';

const Contact = () => {
  const contactInfo = [
    { 
      icon: FiMapPin, 
      title: 'Our Head Office', 
      detail: 'Vitro Globe Travel World, Unit no. 317 Tower B4, Spaze I-Tech Park, Sector 49, Sohna Road, Gurgaon, Haryana 122018' 
    },
    { icon: FiPhone, title: 'Call for Help', detail: '+91 8624876371' },
    { icon: FiMail, title: 'Email for Information', detail: 'Vitroglobeind@gmail.com' },
  ];

  return (
    <section id="contact" className="py-24 bg-charcoal relative border-t border-cyan/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="text-3xl sm:text-4xl font-heading font-bold text-white mb-4">
              Get In <span className="text-cyan">Touch</span>
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-cyan to-transparent mx-auto"></div>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {contactInfo.map((info, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-navy p-8 rounded-2xl border border-cyan/10 text-center flex flex-col items-center gap-4 hover:border-cyan/30 transition-colors h-full"
            >
              <div className="w-16 h-16 bg-gradient-to-br from-cyan/20 to-transparent rounded-full flex items-center justify-center border border-cyan/20 text-cyan flex-shrink-0">
                <SafeIcon icon={info.icon} className="w-8 h-8" />
              </div>
              <h3 className="text-lg font-heading font-bold text-white">{info.title}</h3>
              <p className="text-slate-400 text-sm">{info.detail}</p>
            </motion.div>
          ))}
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-4xl mx-auto bg-navy p-8 sm:p-12 rounded-3xl border border-cyan/20 glow-border"
        >
          <form className="grid grid-cols-1 sm:grid-cols-2 gap-6" onSubmit={(e) => e.preventDefault()}>
            <div>
              <label className="block text-sm font-medium text-slate-400 mb-2">Your Name</label>
              <input type="text" className="w-full bg-charcoal border border-cyan/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-cyan focus:ring-1 focus:ring-cyan transition-all" placeholder="John Doe" />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-400 mb-2">Your Email</label>
              <input type="email" className="w-full bg-charcoal border border-cyan/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-cyan focus:ring-1 focus:ring-cyan transition-all" placeholder="john@example.com" />
            </div>
            <div className="sm:col-span-2">
              <label className="block text-sm font-medium text-slate-400 mb-2">Phone Number</label>
              <input type="tel" className="w-full bg-charcoal border border-cyan/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-cyan focus:ring-1 focus:ring-cyan transition-all" placeholder="+91 8624876371" />
            </div>
            <div className="sm:col-span-2">
              <label className="block text-sm font-medium text-slate-400 mb-2">Your Message</label>
              <textarea rows="4" className="w-full bg-charcoal border border-cyan/10 rounded-xl px-4 py-3 text-white focus:outline-none focus:border-cyan focus:ring-1 focus:ring-cyan transition-all resize-none" placeholder="How can we help you?"></textarea>
            </div>
            <div className="sm:col-span-2 text-center mt-4">
              <button className="bg-cyan text-navy px-10 py-4 rounded-full font-bold hover:bg-white transition-all w-full sm:w-auto shadow-[0_0_20px_rgba(0,240,255,0.4)] glow-border">
                Send Message
              </button>
            </div>
          </form>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;